export default __webpack_public_path__ + "img/d42f4a91509c6b5c0012675855363dff.svg";